import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search } from "lucide-react";

export interface UserFiltersState {
  search: string;
  role: string;
  status: string;
  paymentStatus: string;
}

interface UserFiltersProps {
  filters: UserFiltersState;
  onFiltersChange: (filters: UserFiltersState) => void;
}

export const UserFilters = ({ filters, onFiltersChange }: UserFiltersProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-6">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar por nombre, apellido o usuario..."
          value={filters.search}
          onChange={(e) =>
            onFiltersChange({ ...filters, search: e.target.value })
          }
          className="pl-9"
        />
      </div>

      <Select
        value={filters.role}
        onValueChange={(value) => onFiltersChange({ ...filters, role: value })}
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Rol" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los roles</SelectItem>
          <SelectItem value="admin">Admin</SelectItem>
          <SelectItem value="manager">Manager</SelectItem>
          <SelectItem value="profesor">Profesor</SelectItem>
          <SelectItem value="socio">Socio</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.status}
        onValueChange={(value) =>
          onFiltersChange({ ...filters, status: value })
        }
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Estado" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los estados</SelectItem>
          <SelectItem value="active">Activo</SelectItem>
          <SelectItem value="banned">Baneado</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={filters.paymentStatus}
        onValueChange={(value) =>
          onFiltersChange({ ...filters, paymentStatus: value })
        }
      >
        <SelectTrigger className="w-full sm:w-[180px]">
          <SelectValue placeholder="Cuota" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas las cuotas</SelectItem>
          <SelectItem value="upToDate">Al día</SelectItem>
          <SelectItem value="expired">Vencida</SelectItem>
          <SelectItem value="noPayments">Sin pagos</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
